import { render, staticRenderFns } from "./Reginsmal.vue?vue&type=template&id=45d4f91b&scoped=true&"
import script from "./Reginsmal.vue?vue&type=script&lang=js&"
export * from "./Reginsmal.vue?vue&type=script&lang=js&"
import style0 from "./Reginsmal.vue?vue&type=style&index=0&id=45d4f91b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d4f91b",
  null
  
)

export default component.exports